var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.25 1.25C23.863.812 22.337.625 20.875.625c-2.438 0-5.063.5-6.875 1.875C12.187 1.125 9.562.625 7.125.625c-2.438 0-5.063.5-6.875 1.875v18.313c0 .312.313.625.625.625.125 0 .188-.063.313-.063C2.875 20.562 5.313 20 7.125 20c2.438 0 5.063.5 6.875 1.875C15.688 20.812 18.75 20 20.875 20c2.063 0 4.188.375 5.938 1.313a.563.563 0 00.312.062c.313 0 .625-.313.625-.625V2.5c-.75-.563-1.563-.938-2.5-1.25zm0 16.875c-1.375-.438-2.875-.625-4.375-.625-2.125 0-5.188.813-6.875 1.875V5c1.688-1.063 4.75-1.875 6.875-1.875 1.5 0 3 .188 4.375.625v14.375z",
    id: "resources__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#resources__a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.79b8996765cced3f944b01066f82d5d9.svg";
export { ForwardRef as ReactComponent };